(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/components/prolong-bottom-sheet.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/components/prolong-bottom-sheet.js');

'use strict';

const {
  useContext,
  useEffect
} = React;
const {
  ReactBottomSheet: {
    BottomSheet
  }
} = svs.ui;
const {
  context: {
    ProlongContext
  },
  components: {
    DaysSelection,
    DurationSelection,
    GameDatesInfo,
    PayFooter
  },
  pay: {
    handlePay
  }
} = svs.numbergames.prolong_game;
const ProlongBottomSheet = _ref => {
  let {
    behavior,
    headerTitle,
    isFixed,
    isExpanded,
    onStateChange
  } = _ref;
  const prolongContext = useContext(ProlongContext);
  const {
    wasReturnedFromDeposit,
    shouldResumePayment,
    wager: {
      productName
    }
  } = prolongContext;
  useEffect(() => {
    if (shouldResumePayment) {
      handlePay(prolongContext, true);
    }
  }, [shouldResumePayment]);
  useEffect(() => {
    svs.components.analytics.trackEvent({
      category: 'My Gaming',
      action: 'prolong_activeDialog',
      opt_label: productName
    });
  }, []);
  if (shouldResumePayment && wasReturnedFromDeposit) {
    return null;
  }
  return React.createElement(BottomSheet, {
    behavior: behavior,
    className: "prolong-game-bottom-sheet",
    headerTitle: headerTitle,
    isFixed: isFixed,
    isExpanded: isExpanded,
    onStateChange: onStateChange,
    customer: "tur"
  }, React.createElement("div", {
    className: "padding-xs-h-1 padding-md-h-2"
  }, React.createElement(DaysSelection, null), React.createElement(DurationSelection, null), React.createElement(GameDatesInfo, null)), React.createElement(PayFooter, null));
};
setGlobal('svs.numbergames.prolong_game.components.ProlongBottomSheet', ProlongBottomSheet);

 })(window);